var _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBurgerIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 16",
    ref: svgRef
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.244,
    y: 6.534,
    width: 21.511,
    height: 2.933,
    rx: 1.467,
    fill: "#1D1B84"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.244,
    y: 0.916,
    width: 21.511,
    height: 2.933,
    rx: 1.467,
    fill: "#1D1B84"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.244,
    y: 12.151,
    width: 21.511,
    height: 2.933,
    rx: 1.467,
    fill: "#1D1B84"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurgerIcon);
export default "/_next/static/images/f0c0340848c1fc6d68bba6babb610888.svg";
export { ForwardRef as ReactComponent };